import { render, staticRenderFns } from "./DragAndDropImage.vue?vue&type=template&id=0642ab56&scoped=true"
import script from "./DragAndDropImage.vue?vue&type=script&lang=js"
export * from "./DragAndDropImage.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropImage.vue?vue&type=style&index=0&id=0642ab56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642ab56",
  null
  
)

export default component.exports